import { gql } from "gql";

export const AI_ASSISTANT_SUBSCRIPTION = gql(/* GraphQL */ `
  subscription AiAssistant($question: String!, $chatId: ID) {
    aiAssistant(question: $question, chatId: $chatId) {
      ...AiChatMessageType
    }
  }
`);
